import React from "react";
import { Link } from "react-router-dom";
import Arrow from "../assets/images/Arrow.png";
import EmpowerBanner from "../assets/images/EmpowerBanner.png";

export const EmpoweringSection = () => {
  return (
    <section
      className="EmpoweringSection"
      style={{ backgroundImage: `url(${EmpowerBanner})` }}
    >
      <div className="container">
        <div className="row EmpoweringContent-div">
          <div className="EmpoweringContent ">
            <h1>About The Boat</h1>
          </div>
          <div className="col-lg-5 col-sm-12">
            <div className="EmpoweringContent-left ">
              <p>2013 Cruisers Yachts 540 Sport Coupe</p>
              <p>58ft Overall</p>
              <p>16ft Beam</p>
              <p> 2 Stateroom 2 Head</p>
              <p>Large Couch And TV Down Below</p>
              <p>Helm Is Complete With The Latest Garmin Electronics To Keep The Boat As Informed And Safe As Possible.</p>
              <p>Large Open Aft Area, Designed For Entertaining. Speakers Throughout. This Area Is Fully Air Conditioned For Those Texas Summer Days, Or Heated For The Cooler Days.</p>
            </div>
          </div>
          <div className="col-lg-5 col-sm-12">
            <div className="EmpoweringContent-right ">
              <p>Ice Maker And Mini Fridge Under A Large Bar Area With Sink.</p>
              <p>
                Step Up A Few Steps, Through The Windshield, To The Large Open
                Bow Area, With A Large Sun Pad And Forward Facing Speakers.
              </p>
              <p>
                Aft, There Is A 4ft Hydraulic Swim Platform, That Can Be Lowered
                Down To Two Feet Under The Water.
              </p>
              <p>12ft Walker Bay Tender Is Included In Longer Trips.</p>
              <p>
                Entire Helm Area, Aft Area And Swim Platform, Are Covered In Sea
                Deck, Making It Comfortable To Walk On.
              </p>
            </div>
          </div>
          <div>
            <div className="EmpoweringContent">
              <Link to="#" className="explore-button">
                <button>
                  Explore more <img src={Arrow} alt="Arrow" />
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
